export default "__VITE_ASSET__0fda1cb5__"